// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Action Button Styles
 * Used across all tables (orders, drafts, etc.)
 *
 * TO CHANGE BUTTON SIZE GLOBALLY:
 * Edit the width/height/padding/font-size in .action-btn below
 */

.action-btn {
  /* Size - change these values to adjust button size everywhere */
  width: 110px;
  height: 34px;
  padding: 6px 12px;
  font-size: 0.875rem;

  /* Layout */
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* Appearance */
  background-color: white;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  white-space: nowrap;
  line-height: 1.5;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Color variants - Outline style */
.action-btn-primary {
  border-color: #4D64C1;
  color: #4D64C1;
}

.action-btn-primary:hover:not(:disabled) {
  background-color: #4D64C1;
  color: white;
}

.action-btn-success {
  border-color: #2E7D32;
  color: #2E7D32;
}

.action-btn-success:hover:not(:disabled) {
  background-color: #2E7D32;
  color: white;
}

.action-btn-secondary {
  border-color: #6c757d;
  color: #6c757d;
}

.action-btn-secondary:hover:not(:disabled) {
  background-color: #6c757d;
  color: white;
}

.action-btn-info {
  border-color: #17a2b8;
  color: #17a2b8;
}

.action-btn-info:hover:not(:disabled) {
  background-color: #17a2b8;
  color: white;
}

.action-btn-danger {
  border-color: #dc3545;
  color: #dc3545;
}

.action-btn-danger:hover:not(:disabled) {
  background-color: #dc3545;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ActionButton.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,gEAAgE;EAChE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;;EAEnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd","sourcesContent":["/**\n * Action Button Styles\n * Used across all tables (orders, drafts, etc.)\n *\n * TO CHANGE BUTTON SIZE GLOBALLY:\n * Edit the width/height/padding/font-size in .action-btn below\n */\n\n.action-btn {\n  /* Size - change these values to adjust button size everywhere */\n  width: 110px;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 0.875rem;\n\n  /* Layout */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  /* Appearance */\n  background-color: white;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 4px;\n  white-space: nowrap;\n  line-height: 1.5;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Color variants - Outline style */\n.action-btn-primary {\n  border-color: #4D64C1;\n  color: #4D64C1;\n}\n\n.action-btn-primary:hover:not(:disabled) {\n  background-color: #4D64C1;\n  color: white;\n}\n\n.action-btn-success {\n  border-color: #2E7D32;\n  color: #2E7D32;\n}\n\n.action-btn-success:hover:not(:disabled) {\n  background-color: #2E7D32;\n  color: white;\n}\n\n.action-btn-secondary {\n  border-color: #6c757d;\n  color: #6c757d;\n}\n\n.action-btn-secondary:hover:not(:disabled) {\n  background-color: #6c757d;\n  color: white;\n}\n\n.action-btn-info {\n  border-color: #17a2b8;\n  color: #17a2b8;\n}\n\n.action-btn-info:hover:not(:disabled) {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.action-btn-danger {\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.action-btn-danger:hover:not(:disabled) {\n  background-color: #dc3545;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
